'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _contactDetails = require('@marmalade/validation/lib/bundles/contact-details');
var _contactDetails2 = _interopRequireDefault(_contactDetails);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _oneOf = require('@marmalade/validation/lib/one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _driverInformation = require('../shared/driver-information');
var _driverInformation2 = _interopRequireDefault(_driverInformation);
var _knockOut = require('../shared/knock-out');
var _knockOut2 = _interopRequireDefault(_knockOut);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
exports.default = function (titleOptions, employmentOptions, accessToken) {
  return Object.assign({}, (0, _contactDetails2.default)(), (0, _driverInformation2.default)(titleOptions, employmentOptions), _knockOut2.default, {
    email: (0, _oneByOne2.default)(_contactDetails.email, isValidEmail(accessToken)),
    marketingOptIn: (0, _oneOf2.default)(['Y', 'N'])
  });
};
var isValidEmail = function isValidEmail(accessToken) {
  return function () {
    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(value, values) {
      var options, _ref2, data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = accessToken ? {
                headers: {
                  Authorization: 'Bearer ' + accessToken
                }
              } : null;
              _context.prev = 1;
              _context.next = 4;
              return _axios2.default.post(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/email-product-check/ldi?hasHadPolicyOnly=1', {
                email: value
              }, options);
            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;
              if (!data.data.emailExists) {
                _context.next = 8;
                break;
              }
              return _context.abrupt('return', "Good news! We recognise your email.");
            case 8:
              return _context.abrupt('return', '');
            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](1);
              return _context.abrupt('return', '');
            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};